import { ENV, ENV_ENUM, LOCAL_PORTAL_URL, LINK_REDIRECT_AWS_BIOCARE_PORTAL } from '@/shared/config';
import _ from 'lodash';
import { awsExportAlpha, awsExportCustomer, awsExportDelta, awsExportStaging } from './awsExports';

/**
 * Picks the Cognito OAuth redirect target for the Mercy portal build. Returns the local redirect constant when the hostname contains localhost, otherwise the supplied URL.
 *
 * @param url - Deployed redirect URL to use outside localhost.
 * @returns Redirect URL matching the current hostname.
 */
const generateLinkRedirectAws = (url: any) => {
  if (_.includes(window.location.hostname, 'localhost')) {
    return LOCAL_PORTAL_URL;
  }
  return url;
};

const AWS_EXPORT_BY_ENV = {
  [ENV_ENUM.alpha]: awsExportAlpha,
  [ENV_ENUM.delta]: awsExportDelta,
  [ENV_ENUM.staging]: awsExportStaging,
  [ENV_ENUM.customer]: awsExportCustomer,
};

const LINK_CONFIG = {
  LINK_REDIRECT_AWS: generateLinkRedirectAws(LINK_REDIRECT_AWS_BIOCARE_PORTAL),
  AWS_CONFIG: AWS_EXPORT_BY_ENV[ENV],
};

export default LINK_CONFIG;
